import React, {useEffect, useState} from 'react';
import Modal from 'react-bootstrap/Modal';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import Link from '@material-ui/core/Link';
import {useTranslation} from "react-i18next";
import TextInput from "../Fields/TextInput";
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
	modalClassConDSI: {
		position: 'absolute',
		width: '114%',
		height: '82%',
		padding: '35px 15px 0px',
		right: 'auto',
		bottom: 'auto',
	},
	modalClassConDSIDark: {
		position: 'absolute',
		width: '114%',
		height: '82%',
		padding: '35px 15px 0px',
		right: 'auto',
		bottom: 'auto',
		backgroundColor: '#292929'
	},
	modalBoxContent: {
		maxHeight: '600px',
	},
	modalText: {
		position: 'absolute',
		top: '10px',
		right: '10px'
	},
}));

const DiscoverSaveResultsModal = props => {
	const { t } = useTranslation("common");
	const classes = useStyles();
	const [title, setTitle] = useState('');
	const [saveResultAsError, setSaveResultAsError] = useState(false);
	const toggle = useSelector(state => state.setToggle.toggle);

	useEffect(() => {
		document.getElementById("title")?.focus();
	})

	const callback = () => {
		// Get by DOM instead of title, especially for the default value case
		let val = document.getElementById("title").value;
		if (val && val.trim().length > 0 && val.length <= 188) {
			setSaveResultAsError(false);
			props.actionModal(props.fieldConfig, props.filter, props.resInfo, val, props.downloadType, 'all');
		} else {
			setSaveResultAsError(true);
		}
	}

	const closeModal = () => {
		setSaveResultAsError(false);
		props.closeModal();
	}

	const changeTitle = (e) => {
		checkTitle(e.target.value);
	}

	function checkTitle(title) {
		let val = title;
		setTitle(val);
		if (!val || val.trim().length === 0 || val.length > 188) {
			setSaveResultAsError(true);
		} else {
			setSaveResultAsError(false);
		}
	}

	return (
		<Modal
			size="lg"
			aria-labelledby="contained-modal-title-vcente"
			centered
			show={props.showModal}
			contentClassName={toggle ? classes.modalClassConDSI : classes.modalClassConDSIDark}
		>
			<Link href="#" onClick={(e) => e.preventDefault()} className={classes.modalText}>
				<CloseIcon style={{fill : '#777777' }} onClick={closeModal} />
			</Link>
			<br></br>
			<div className={toggle ? "jumbotron appTextColor": "jumbotronDark appTextColor" } style = {{height: '90%'}}>
				<h2>{t("saveResultAs")}</h2>
				<p style={{fontFamily: 'Helvetica', fontWeight: '200', wordSpacing: '-2px'}}>
					{t("saveResultAsBody")}
				</p>
				<div>
					<label style={{padding: '0px'}}>Result Name</label>&nbsp;&nbsp;
					<TextInput id="title" name="title" variant="outlined" onChange={changeTitle}
							   inputProps={{maxLength: 188}} defaultValue={title || props.defaultTitle}
							   error={saveResultAsError} fullWidth={true} autoFocus={true} spellcheck="false"
							   helperText={saveResultAsError ? t('required') : ""}/>
				</div>
				<div style={{padding: '20px'}}>
					<button onClick={callback} className="pull-right large-button gqblue">Save</button>
					<button onClick={closeModal} className="pull-right large-button grey">Cancel</button>
				</div>
			</div>
		</Modal>
	);
}

export default DiscoverSaveResultsModal;
